"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { Truncate } from '../Truncate/index.mjs';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const NoOptionsHeading = forwardRef(({ className, text, ...props }, ref) => {
  const styles = dropdownRecipe();
  return /* @__PURE__ */ jsxs("span", { role: "heading", "aria-level": 2, className: clsx(styles["no-options-heading"], className), ...props, ref, children: [
    /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.ZoomCancel, className: styles["no-options-heading-icon"] }),
    /* @__PURE__ */ jsx(Truncate, { children: text })
  ] });
});

export { NoOptionsHeading };
